import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Login } from '../login/login.model';
import { environment } from '../../../environments/environment';
import { AuthData } from './auth.model';

export const LOGOUT_URL = environment.serverBaseUrl + 'logout';
export const LOGIN_URL = environment.serverBaseUrl + 'login';

@Injectable({ providedIn: 'root' })
export class AuthServerProvider {
  constructor(private http: HttpClient) {}

  login(credentials: Login): Observable<AuthData> {
    return this.http.post<AuthData>(LOGIN_URL, credentials);
  }

  impersonateUser(token: string): Observable<AuthData> {
    return this.http.post<AuthData>(`${environment.serverBaseUrl}/login/auth-by-token`, { token: token });
  }

  logout(): Observable<void> {
    // logout from the server
    return this.http.post(LOGOUT_URL, {}).pipe(
      map(() => {
        // to get a new csrf token call the api
        this.http.get(environment.serverBaseUrl + 'user').subscribe();
      })
    );
  }
}
